import React, { useEffect, useState } from "react";
import LeaveComp from "../leaveComponents/leave.comp";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import DashboardCard from "../../../component/dashboardCard";
import { CheckBox } from "@mui/icons-material";
import LeaveManagement from "../leaveComponents/leave.management";
import { getLeaveSummary } from "../../../api/leaves";
import { handleAxiosError } from "../../../config/action-config";
import { useDispatch, useSelector } from "react-redux";

export default function LeaveDashboard() {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [leaveSummaryData, setLeaveSummaryData] = useState({});

  async function leaveSummary() {
    try {
      const { data } = await getLeaveSummary({}, user.token);
      setLeaveSummaryData(data.data);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  useEffect(() => {
    if (user.token) {
      leaveSummary();
    }
  }, []);
  return (
    <div className="container-dash">
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography variant="h1" className="pmt-headings-h1">
              Leave Distribution
            </Typography>
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <Box className="card-radious card-inventory-1">
              <DashboardCard
                total={leaveSummaryData.total}
                tittle={"Total Leave"}
              >
                <CheckBox
                  sx={{ fontSize: 40 }}
                  // className="mui-icon yellow-bkg"
                  className="mui-icon"
                />
              </DashboardCard>
            </Box>
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <Box className="card-radious card-inventory-2">
              <DashboardCard
                total={leaveSummaryData.totalSickLeaves}
                tittle={"Sick Leave"}
              >
                <CheckBox className="mui-icon" />
              </DashboardCard>
            </Box>
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <Box className="card-radious card-inventory-2">
              <DashboardCard
                total={leaveSummaryData.totalCasualLeaves}
                tittle={"Casual Leave"}
              >
                <CheckBox className="mui-icon" />
              </DashboardCard>
            </Box>
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <Box className="card-radious card-inventory-1">
              <DashboardCard
                total={leaveSummaryData.totalPrivilegeLeaves}
                tittle={"Privilege Leave"}
              >
                <CheckBox
                  sx={{ fontSize: 40 }}
                  // className="mui-icon yellow-bkg"
                  className="mui-icon"
                />
              </DashboardCard>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h1" className="pmt-headings-h1">
            Left Leave
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <LeaveComp.LeftLeave
            text={"Total Leave"}
            Num={leaveSummaryData.leftTotalLeaves}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <LeaveComp.LeftLeave
            text={"Casual Leave"}
            Num={leaveSummaryData.leftCasualLeaves}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <LeaveComp.LeftLeave
            text={"Sick Leave"}
            Num={leaveSummaryData.leftSickLeaves}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <LeaveComp.LeftLeave
            text={"Privilege Leave"}
            Num={leaveSummaryData.leftPrivilegeLeaves}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <LeaveManagement refreshApi={leaveSummary} />
        </Grid>
      </Grid>
    </div>
  );
}
{
}
